import React from "react";
import Container from "react-bootstrap/Container";
import OfferList from "./OfferList";
import Spinner from "react-bootstrap/Spinner";
import PaginationBar from "./PaginationBar";
import { OffersListViewProps } from "../../types";


const OffersListView = (props: OffersListViewProps) => {
    return (
        <Container>
            {props.loading ? (
                <Container className='loading'>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </Container>
            ) : (
                <>
                    <OfferList 
                        offers={props.currentOffers}
                         manageMode={props.manageMode}
                    />

                    <PaginationBar
                        totalPages={props.totalPages}
                        currentPage={props.currentPage}
                        handlePageChange={props.handlePageChange}
                    />
                </>
            )}
        </Container>
    )
}

export default OffersListView;